import React, { useState } from 'react';
import './Products.css';
import { Container, Modal, Card } from 'react-bootstrap';
import AnimateOnScroll from '../components/AnimateOnScroll';
import PaymentMethodsBlock from '../components/PaymentMethodsBlock';
import 'bootstrap/dist/css/bootstrap.min.css';
import BT01 from '../assets/BTOne/BT01.png';
import BT02 from '../assets/BTOne/BT02.png';
import BT03 from '../assets/BTOne/BT03.png';
import BT04 from '../assets/BTOne/BT04.png';
import BT05 from '../assets/BTOne/BT05.png';


import BTOO1 from '../assets/BTOO/BTOO01.png';
import BTOO2 from '../assets/BTOO/BTOO02.png';
import adaptadorImg from '../assets/adaptador/adaptador.png';
import { FaWhatsapp, FaAndroid } from 'react-icons/fa';
import { buildWhatsAppUrl } from '../constants/whatsapp';

const buildWhatsappUrl = (nomeProduto) =>
  buildWhatsAppUrl(`Olá! Tenho interesse no produto: ${nomeProduto}`);

const Products = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [closingProduct, setClosingProduct] = useState(null);
  const [zoomImage, setZoomImage] = useState('');

  const produtos = [
    {
      id: 1,
      nome: "BTOne - Dispositivo para Análise e Treinamento Respiratório",
      imagens: [
        BT01,
        BT02,
        BT03,
        BT04,
        BT05
     
      ],
      preco: 'R$ 1.200,00',
      /** Valor numérico para simulação PIX/cartão (sem frete). */
      precoNumerico: 1200,
      androidOnly: true,
      descricao: {
        principal: "Dispositivo avançado para análise e treinamento respiratório, incluindo medição de PiMax e PeMax. Acompanhado de aplicativo dedicado para gerenciamento de pacientes e avaliações.",
        caracteristicas: [
          "Equipado com manômetro eletrônico para teste e monitoramento de fluxos inspiratórios e expiratórios",
          "Treinamento simultâneo de inspiração e expiração",
          "6 níveis de inalação e 6 níveis de exalação",
          "Inclui maleta para transporte",
          "Clipe nasal incluso",
          "Tubo de conexão",
          "Análise precisa de PiMax e PeMax",
          "Aplicativo dedicado para gerenciamento de pacientes",
          "Sistema de avaliação e geração de relatórios integrado",
          "Armazenamento local de dados dos pacientes",
          "Interface intuitiva para profissionais",
          "Compatibilidade com smartphones e tablets"
        ],
        especificacoes: [
          "Embalagem interna: 21 x 7,5 x 6,5cm",
          "Tamanho da caixa: 42 x 38 x 39cm",
          "Peso líquido/bruto: 6/6,9KGS",
          "Dispositivo funciona apenas com smartphones Android"
        ]
      },
      appInfo: {
        titulo: "BTOne - Aplicativo PulmoScan Completo",
        descricao: "O BTOne vem com o aplicativo PulmoScan, uma solução profissional completa com IA integrada que inclui funcionalidades de avaliação e o PulmoGame, um módulo de treinamento respiratório com jogos interativos.",
        recursos: [
          {
            nome: "PulmoScan - Funcionalidades Principais",
            features: [
              "Sistema de avaliação respiratória com IA",
              "Geração de relatórios detalhados com análise inteligente",
              "Cadastro completo de pacientes",
              "Monitoramento em tempo real dos dados",
              "Armazenamento local seguro dos dados",
              "Interface profissional intuitiva",
              "Compartilhamento de relatórios via PDF",
              "Histórico completo de avaliações",
              "Análise precisa de PiMax e PeMax",
              "Módulo PulmoGame integrado"
            ]
          },
          {
            nome: "PulmoGame - Módulo de Jogos Terapêuticos",
            features: [
              "PulmoPlane: Jogo de avião para treinamento inspiratório e expiratório",
              "PulmoRocket: Foguete focado em treinamento expiratório",
              "PulmoSpider: Aranha para treinamento inspiratório específico",
              "Sistema de gamificação com pontuação e níveis",
              "Interface divertida e envolvente para pacientes",
              "Diferentes níveis de dificuldade progressiva",
              "Acompanhamento detalhado do progresso",
              "Ideal para aumentar adesão ao tratamento",
              "Integrado ao sistema de avaliação principal"
            ]
          }
        ]
      }
    },
    {
      id: 2,
      nome: "BTTwo - Peak Flow Meter Pro",
      imagens: [BTOO1, BTOO2],
      preco: 'R$ 929,90',
      precoNumerico: 929.9,
      descricao: {
        principal: "Peak Flow Meter Pro - Medidor de Pico de Fluxo Expiratório Profissional com conectividade Bluetooth.",
        caracteristicas: [
          "Mede PEF & PEV1",
          "Suporte para cálculo de válvula prevista",
          "Conexão Bluetooth integrada",
          "Recarregável com conector tipo C",
          "Armazena 300 registros históricos",
          "Tela OLED maior para melhor visualização",
          "Exibição com divisão em 3 zonas",
          "Permite ajuste de tempo",
          "Permite sincronização de dados",
          "Bocal extra incluído"
        ],
        especificacoes: [
          "Embalagem interna: 6 x 7 x 19cm",
          "Tamanho da caixa: 50 x 45 x 40cm",
          "Peso líquido/bruto: 18.2/19.2KGS"
        ]
      }
    },
    {
      id: 3,
      nome: "Adaptador de bocal para BTOne",
      imagens: [adaptadorImg],
      consultarValor: true,
      descricao: {
        principal:
          "Acessório que substitui o bocal padrão do BTOne, permitindo uso com filtros de barreira e HMEF, conexão a máscaras e acoplamento seguro à traqueostomia — ampliando as indicações clínicas do equipamento.",
        caracteristicas: [
          "Compatível com o dispositivo BTOne",
          "Uso com filtros de barreira e HMEF na linha inspiratória/expiratória conforme protocolo clínico",
          "Permite acoplar o equipamento a máscaras (interface adequada ao circuito)",
          "Possibilita conexão à traqueostomia quando indicado pelo profissional",
          "Facilita circuitos fechados e medidas com maior segurança em determinados contextos assistenciais",
          "Design pensado para encaixe estável com o corpo do BTOne"
        ],
        especificacoes: [
          "Acessório: adaptador de bocal Bientech para BTOne",
          "Imagens ilustram configuração com bocal, filtro/HMEF e vias alternativas de interface",
          "Orientações de uso, máscaras e filtros conforme prescrição e normas da instituição"
        ]
      }
    }
  ];

  const handleZoomClick = (image) => {
    setZoomImage(image);
    setShowModal(true);
  };

  const handleProductClick = (produto) => {
    if (selectedProduct?.id === produto.id) {
      setClosingProduct(produto.id);
      setTimeout(() => {
        setSelectedProduct(null);
        setClosingProduct(null);
      }, 350);
    } else {
      setClosingProduct(null);
      setSelectedProduct(produto);
      setSelectedImage(0);

      requestAnimationFrame(() => {
        const element = document.getElementById('product-details');
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  };

  return (
    <Container className="products-container">
      <AnimateOnScroll variant="fadeUp">
        <h1 className="text-center mb-2">Nossos Produtos</h1>
        <p className="products-page-lead text-center mb-5">
          Compra de <strong>equipamentos e acessórios</strong>. Para assinatura do app (mensal ou anual), acesse{' '}
          <strong>Assinatura</strong> no menu.
        </p>
      </AnimateOnScroll>
      
      <AnimateOnScroll variant="fadeUp" delay={100}>
      <div className="products-list">
        {produtos.map((produto) => (
          <div key={produto.id} className={`product-item-wrapper ${selectedProduct?.id === produto.id ? 'expanded' : ''}`}>
            <Card 
              className={`product-preview-card ${selectedProduct?.id === produto.id ? 'active' : ''}`}
              onClick={() => handleProductClick(produto)}
              style={{ cursor: 'pointer' }}
            >
              {produto.androidOnly && (
                <div className="android-badge-top">
                  <FaAndroid className="android-icon-badge" />
                  <span>Apenas Android</span>
                </div>
              )}
              <div className="product-image-wrapper">
                <Card.Img 
                  variant="top" 
                  src={produto.imagens[0]}
                  className="product-preview-image"
                />
              </div>
              <Card.Body>
                <Card.Title>
                  {produto.nome}
                </Card.Title>
                <Card.Text>{produto.descricao.principal}</Card.Text>
                <div className="price-container product-price-row">
                  <div className="product-price-card-preview">
                    {produto.consultarValor ? (
                      <span className="product-price-amount product-price-amount--consulta">
                        Consulte o valor
                      </span>
                    ) : (
                      <>
                        <span className="product-price-amount">{produto.preco}</span>
                        <span className="product-price-frete">+ frete</span>
                      </>
                    )}
                  </div>
                  <a
                    href={buildWhatsappUrl(produto.nome)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="product-whatsapp-btn product-whatsapp-btn--compact"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FaWhatsapp aria-hidden />
                    <span>WhatsApp</span>
                  </a>
                </div>
              </Card.Body>
            </Card>

            {selectedProduct?.id === produto.id && (
              <div className={`product-details-wrapper ${closingProduct === produto.id ? 'closing' : ''}`} id="product-details">
                <div className="product-row">
                  <div className="product-column">
                    <div className="product-detail-images">
                      <div 
                        className="main-image-container"
                        onClick={() => handleZoomClick(produto.imagens[selectedImage])}
                        style={{ cursor: 'zoom-in' }}
                      >
                        <img
                          src={produto.imagens[selectedImage]}
                          alt={produto.nome}
                          className="main-product-image"
                        />
                      </div>
                      {produto.imagens.length > 1 && (
                        <div className="thumbnail-container">
                          {produto.imagens.map((imagem, idx) => (
                            <div
                              key={idx}
                              className={`thumbnail ${selectedImage === idx ? 'active' : ''}`}
                              onClick={() => setSelectedImage(idx)}
                            >
                              <img src={imagem} alt={`Thumbnail ${idx + 1}`} />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    
                    {produto.appInfo && (
                      <div className="pulmogame-preview-container">
                        <h3>
                          {produto.appInfo.titulo}
                        </h3>
                        <p className="pulmogame-description">
                          {produto.appInfo.descricao}
                        </p>
                        <div className="apps-features">
                          {produto.appInfo.recursos.map((app, index) => (
                            <div key={index} className="product-app-section">
                              <h4>{app.nome}</h4>
                              <ul className="product-features-list">
                                {app.features.map((feature, i) => (
                                  <li key={i}>{feature}</li>
                                ))}
                              </ul>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  
                  <div className="product-column">
                    <div className="product-info">
                      <h2 className="mb-4">{produto.nome}</h2>
                      
                      <div className="product-preco-frete-row mb-4">
                        <div className="product-preco-card">
                          <span className="product-preco-label">Valor</span>
                          {produto.consultarValor ? (
                            <p className="product-preco-valor product-preco-valor--consulta mb-0">
                              Consulte o valor
                            </p>
                          ) : (
                            <>
                              <p className="product-preco-valor mb-0">{produto.preco}</p>
                              <span className="product-preco-frete-note">+ frete</span>
                            </>
                          )}
                        </div>
                        <a
                          href={buildWhatsappUrl(produto.nome)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="product-whatsapp-btn product-whatsapp-btn--large"
                        >
                          <FaWhatsapp aria-hidden />
                          <span>Comprar pelo WhatsApp</span>
                        </a>
                      </div>

                      {!produto.consultarValor && (
                        <div className="product-payment-section mb-4">
                          <PaymentMethodsBlock
                            baseAmount={produto.precoNumerico}
                            variant="product"
                          />
                        </div>
                      )}

                      <p className="product-description mb-4">{produto.descricao.principal}</p>
                      
                      <div className="features-container mb-4">
                        <h3>Características:</h3>
                        <ul className="feature-list">
                          {produto.descricao.caracteristicas.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>

                      <div className="specs-container mb-4">
                        <h3>Especificações Técnicas:</h3>
                        <ul className="specs-list">
                          {produto.descricao.especificacoes.map((spec, i) => (
                            <li key={i}>{spec}</li>
                          ))}
                        </ul>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      </AnimateOnScroll>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
        className="image-zoom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Visualização Ampliada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="zoom-image-container">
            <img
              src={zoomImage}
              alt="Imagem ampliada"
              className="zoomed-image"
            />
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default Products;